export function isServerError(status){return status>=500}export function tryToClone(response){try{return response.clone()}catch(e){return}}